import { Permissions } from 'src/api/requests'
import { PageBreadcrumbs } from 'src/components'
import { useUser } from 'src/hooks'
import { useLocales } from 'src/locales'

import { PatientQuestionnairesTable, QuestionnairesTable } from '../components'

export const ListQuestionnaires = () => {
  const { t } = useLocales()

  const { hasPermission } = useUser()

  const isPatient = hasPermission(
    Permissions.QUESTIONNAIRES_MENU_ACCESS_PERSONAL_QUESTIONNAIRES
  )

  return (
    <PageBreadcrumbs
      title={t('menu.questionnaires')}
      items={[{ title: t('menu.questionnaires') }]}
    >
      {isPatient ? <PatientQuestionnairesTable /> : <QuestionnairesTable />}
    </PageBreadcrumbs>
  )
}
